const MenuIds = {
  ACCOUNT_AND_PAYMENTS_MENU: "ACCOUNT_AND_PAYMENTS_MENU",
  DEPTH_TEST_MENU: "DEPTH_TEST_MENU",
  ORDERS_MENU: "ORDERS_MENU",
  MY_LISTS_MENU: "MY_LISTS_MENU",
  SHOP_BY_CATEGORY: "SHOP_BY_CATEGORY",
  MEGA_MENU: "MEGA_MENU",
};

export default MenuIds;
